import { ArrowForwardOutlined } from '@mui/icons-material';
import styles from './PlanningCostsCard.module.css';

interface PlanningCostsCardProps {
	informedCount: number;
	totalCount: number;
	isComplete: boolean;
	onClick: () => void;
}

export const PlanningCostsCard = ({
	informedCount,
	totalCount,
	isComplete,
	onClick,
}: PlanningCostsCardProps) => (
	<button type="button" className={styles.card} onClick={onClick}>
		<span className={styles.icon}>R$</span>
		<span className={styles.title}>Custos dos fertilizantes</span>
		<span className={styles.count}>
			· {informedCount} de {totalCount} informados
		</span>
		<span className={`${styles.badge} ${isComplete ? styles.badgeComplete : styles.badgePending}`}>
			{isComplete ? 'Completo' : 'Pendente'}
		</span>
		<span className={styles.action}>
			{isComplete ? 'Ver custos' : 'Informar custos'}
			<ArrowForwardOutlined className={styles.actionIcon} />
		</span>
	</button>
);
